import { RichTextEditor } from '@talentmesh/rte';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

interface RichTextContentProps {
    html: string;
    transparent?: boolean;
    contentEditableClassName?: string;
}

function RichTextContent({ html, transparent, contentEditableClassName }: RichTextContentProps): React.JSX.Element {
    return (
        <RichTextEditor
            initialHtml={html}
            editable={false}
            features="all"
            toolbarProps={{
                className: 'hidden',
            }}
            contentEditableProps={{
                className: cn(
                    'overflow-y-hidden border-0 min-h-0 job-ad-rte text-base [&>p]:text-base',
                    transparent ? 'bg-transparent' : 'bg-inherit',
                    contentEditableClassName,
                ),
            }}
        />
    );
}

export default RichTextContent;
